import React, { useState, useEffect, useRef } from "react";

// Main App component to demonstrate the RightSlidePanel
const SidePanelModal = ({ MyComponent, pushOpen, setpushToOpen, showtype }) => {
  // State to control the visibility of the slide panel
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  useEffect(() => {
    pushOpen && openPanel();
  }, [pushOpen]);

  // Function to open the panel
  const openPanel = () => {
    setIsPanelOpen(true);
  };

  // Function to close the panel
  const closePanel = () => {
    setIsPanelOpen(false);
    setpushToOpen(false);
  };

  return (
    // Style block for pure CSS
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');

       

          .app-container {
            min-height: 100vh;
            background-color: #f3f4f6; /* bg-gray-100 */
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 1rem; /* p-4 */
          }

          .page-title {
            font-size: 2.25rem; /* text-4xl */
            font-weight: 700; /* font-bold */
            color: #1f2937; /* text-gray-800 */
            margin-bottom: 2rem; /* mb-8 */
          }

          .open-button {
            padding: 0.75rem 1.5rem; /* px-6 py-3 */
            background-color: #2563eb; /* bg-blue-600 */
            color: white;
            font-weight: 600; /* font-semibold */
            border-radius: 0.5rem; /* rounded-lg */
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); /* shadow-md */
            transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
            border: none;
            cursor: pointer;
            outline: none;
          }

          .open-button:hover {
            background-color: #1d4ed8; /* hover:bg-blue-700 */
          }

          .open-button:focus {
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.5); /* focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 */
          }

          .overlay {
            position: fixed;
            inset: 0;
            background-color: rgba(0, 0, 0, 0.5); /* bg-black bg-opacity-50 */
            z-index: 40;
            transition: opacity 0.3s ease-in-out;
          }

          .slide-panel {
            position: fixed;
            top: 0;
            right: 0;
            height: 100vh; /* h-full */
            /*  width: 320px;w-80 */
            background-color: white;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1); /* shadow-lg */
            z-index: 50;
            transform: translateX(100%); /* translate-x-full */
            transition: transform 0.3s ease-in-out;
            border-top-left-radius: 0.5rem; /* rounded-l-lg */
            border-bottom-left-radius: 0.5rem; /* rounded-l-lg */
            display: flex;
            flex-direction: column;
          }

          .slide-panel.open {
            transform: translateX(0); /* translate-x-0 */
          }

          .panel-header {
            display: flex;
            justify-content: flex-end;
            padding: 1rem; /* p-4 */
            padding-bottom: 0; /* pb-0 */
          }

          .close-button {
            background: none;
            border: none;
            font-size: 2rem; /* text-2xl */
            font-weight: 700; /* font-bold */
            color: #6b7280; /* text-gray-500 */
            cursor: pointer;
            transition: color 0.3s ease-in-out;
            outline: none;
          }

          .close-button:hover {
            color: #374151; /* hover:text-gray-700 */
          }

          .panel-content-wrapper {
            flex-grow: 1; /* flex-grow */
            overflow-y: auto; /* overflow-y-auto */
          }

          .panel-inner-content {
            padding: 1.5rem; /* p-6 */
          }

          .panel-title {
            font-size: 1.875rem; /* text-3xl */
            font-weight: 700; /* font-bold */
            color: #1f2937; /* text-gray-800 */
            margin-bottom: 1rem; /* mb-4 */
          }

          .panel-text {
            color: #4b5563; /* text-gray-600 */
            margin-bottom: 1.5rem; /* mb-6 */
          }

          .inner-close-button {
            margin-top: 1.5rem; /* mt-6 */
            padding: 0.5rem 1rem; /* px-4 py-2 */
            background-color: #ef4444; /* bg-red-500 */
            color: white;
            border-radius: 0.375rem; /* rounded-md */
            transition: background-color 0.3s ease-in-out;
            border: none;
            cursor: pointer;
            outline: none;
          }

          .inner-close-button:hover {
            background-color: #dc2626; /* hover:bg-red-600 */
          }

        

          .custom-component-box {
            background-color: #f3e8ff; /* bg-purple-100 */
            padding: 1rem; /* p-4 */
            margin: 1rem; /* m-4 */
            border-radius: 0.375rem; /* rounded-md */
            box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06); /* shadow-inner */
            color: #6b21a8; /* text-purple-800 */
          }

          .custom-component-box p.semibold {
            font-weight: 600; /* font-semibold */
          }

          .custom-component-box p.small-text {
            font-size: 0.875rem; /* text-sm */
          }

          /* Responsive adjustments */
          @media (max-width: 768px) {
            .slide-panel {
              width: 75%; /* Make it wider on smaller screens */
            }
          }

          @media (max-width: 480px) {
            .slide-panel {
              width: 90%; /* Even wider on very small screens */
            }
            .page-title {
              font-size: 1.75rem;
              text-align: center;
            }
          }
        `}
      </style>

      <div className="">
        {/* Page Title */}

        {/* Button to trigger the slide panel */}
        {/* <button onClick={openPanel} className="open-button">
          Open Side Panel
        </button> */}

        {/* The RightSlidePanel component */}
        {/* It receives the 'isOpen' state and the 'onClose' function as props */}
        {/* Any content placed between the tags will be rendered inside the panel */}
        <RightSlidePanel
          isOpen={isPanelOpen}
          onClose={closePanel}
          showtype={showtype}
        >
          {/* Example content to be displayed inside the slide panel */}
          <div className="panel-inner-content">
            {/* <button onClick={closePanel} className="inner-close-button">
              &times;
            </button>{" "} */}
            <div className="panel-header">
              <button
                onClick={closePanel}
                className=""
                aria-label="Close panel"
              >
                <button onClick={closePanel} className="inner-close-button">
                  &times;
                </button>
              </button>
            </div>
            <h2 className="panel-title">{showtype.toUpperCase()} Report</h2>

            {/* <MyCustomComponent /> Another custom component inside */}
            {MyComponent}
          </div>
        </RightSlidePanel>
      </div>
    </>
  );
};

// RightSlidePanel component
const RightSlidePanel = ({ isOpen, onClose, children, showtype }) => {
  // Ref to the panel content div to handle clicks outside
  const panelRef = useRef(null);

  // Effect to add and remove event listener for clicks outside the panel
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the panel is open and the click is outside the panelRef, close the panel
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      // Add event listener when the panel is open
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]); // Re-run effect if isOpen or onClose changes

  return (
    <>
      {/* Overlay for the background, visible when panel is open */}
      {isOpen && (
        <div
          className="overlay"
          onClick={onClose} // Allows closing by clicking on the overlay
        ></div>
      )}

      {/* The actual slide panel */}
      <div
        ref={panelRef} // Attach ref to the panel content
        className={`slide-panel ${isOpen ? "open" : ""}`}
      >
        <div className="panel-header">
          <button
            onClick={onClose}
            className="close-button"
            aria-label="Close panel"
          >
            &times;
          </button>
        </div>
        {/* Content passed as children */}
        <div className="panel-content-wrapper">{children}</div>
      </div>
    </>
  );
};

// A dummy component to demonstrate passing children
const MyCustomComponent = () => {
  return (
    <div className="custom-component-box">
      <p className="semibold">Hello from MyCustomComponent!</p>
      <p className="small-text">
        This component is rendered inside the slide panel.
      </p>
    </div>
  );
};

export default SidePanelModal;
